module.exports = __webpack_public_path__ + "img/stamp-warranty.be4d4594.png";